import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="public--sound"
//
// A video that plays muted on its own, with one button to hear it.
export default class extends Controller {
  static targets = ["video", "button"]

  toggle() {
    this.videoTarget.muted = !this.videoTarget.muted
    this.element.classList.toggle("is-unmuted", !this.videoTarget.muted)
    this.buttonTarget.setAttribute("aria-label", this.videoTarget.muted ? "Unmute" : "Mute")
  }
}
